/*
 * @Description: 登陆主页面
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-15 17:26:05
 * @LastEditors: jesseding
 * @LastEditTime: 2022-06-21 10:41:54
 */

import { isAppMarket } from '@tencent/syzs-login-sdk-utils';
import { BaseModel } from '../../component';
import { addMobileClassName } from '../../lib';
import { GoogleAndFaceBookButtons } from './GoogleAndFaceBookButtons';
import './LoginMain.less';

const LoginMain = () => (
  <div className={addMobileClassName('login-v2-main')}>
    <BaseModel
      showLeftModule
      showClose={!isAppMarket()}
      fullScreen
    >
      <div className="inner">
        <GoogleAndFaceBookButtons />
      </div>
    </BaseModel>
  </div>
);

export default LoginMain;
